var map = {
	"./leaflet/images/layers": 15,
	"./leaflet/images/layers-2x": 16,
	"./leaflet/images/layers-2x.png": 16,
	"./leaflet/images/layers.png": 15,
	"./leaflet/images/marker-icon": 17,
	"./leaflet/images/marker-icon-2x": 18,
	"./leaflet/images/marker-icon-2x.png": 18,
	"./leaflet/images/marker-icon.png": 17,
	"./leaflet/images/marker-shadow": 19,
	"./leaflet/images/marker-shadow.png": 19,
	"./leaflet/owmloading": 0,
	"./leaflet/owmloading.gif": 0,
	"./openstreetmap/NT2": 3,
	"./openstreetmap/NT2.png": 3,
	"./openstreetmap/ScrollWheel20": 1,
	"./openstreetmap/ScrollWheel20.png": 1,
	"./openstreetmap/ScrollWheelDisabled20": 2,
	"./openstreetmap/ScrollWheelDisabled20.png": 2,
	"./openweather/mapicons/br": 20,
	"./openweather/mapicons/br.png": 20,
	"./openweather/mapicons/catalonia": 21,
	"./openweather/mapicons/catalonia.png": 21,
	"./openweather/mapicons/de": 22,
	"./openweather/mapicons/de.png": 22,
	"./openweather/mapicons/en": 23,
	"./openweather/mapicons/en.png": 23,
	"./openweather/mapicons/es": 24,
	"./openweather/mapicons/es.png": 24,
	"./openweather/mapicons/famfamfam flag icons.txt": 37,
	"./openweather/mapicons/fr": 25,
	"./openweather/mapicons/fr.png": 25,
	"./openweather/mapicons/it": 26,
	"./openweather/mapicons/it.png": 26,
	"./openweather/mapicons/nl": 27,
	"./openweather/mapicons/nl.png": 27,
	"./openweather/mapicons/ru": 28,
	"./openweather/mapicons/ru.png": 28,
	"./openweather/owm.ico": 38,
	"./openweather/owmloading": 29,
	"./openweather/owmloading.gif": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;